module.exports = __webpack_public_path__ + "static/media/edit.751f84c2.svg";